// import { noop } from 'utils'
// import SearchBar from '@components/SearchBar'
// import { ClipLoader } from 'react-spinners'
import { Formik, Form, Number } from 'components/FormV2'
import { DoubleArrowLeft } from 'components/SvgIcons'
import React, { PureComponent } from 'react'
import * as Yup from 'yup'
import {
  FilterBar,
  Dock,
  Body,
  FilterLabel,
  ValueWrapper,
  Input,
  Error,
  PriceContainer,
  HeaderText,
  Feature,
  FeaturesContainer,
  Text,
  // TextWrapper,
  // Footer,
  // Header,
  // HeaderMain,
  // IconWrapper,
  // ClearFilter,
  // ClearFilterContainer,
  // Button,
} from './styles'
import './index.css'

const SearchSchema = Yup.object().shape({
  area: Yup.number()
    .required('Obrigatório')
    .positive('Digite um valor positivo'),
  // finalDate: Yup.date().required('Obrigatório'),
})

class FilterBarComponent extends PureComponent {
  handleInputChange(values, e, field) {
    const { setFilterValues } = this.props
    const value =
      e.target.value || isFinite(e.target.value) ? e.target.value : ''
    e.target.value = value
    this.handleChange(e)
    setFilterValues({
      ...values,
      [field]: value,
    })
  }

  render() {
    const {
      disabled,
      active,
      toggleFilterBar,
      setFilterValues,
      formattedAddress,
    } = this.props
    return (
      <FilterBar active={active}>
        <Dock active={active} onClick={toggleFilterBar}>
          <DoubleArrowLeft
            direction={active ? 'left' : 'right'}
            color="white"
            height={11.19}
          />
        </Dock>
        <Formik
          validationSchema={SearchSchema}
          initialValues={{
            area: '',
            garage: '',
          }}
        >
          {({
            handleSubmit,
            handleReset,
            handleChange,
            values,
            setFieldValue,
            dirty,
            isValid,
            errors,
          }) => {
            this.resetForm = handleReset
            this.formValues = values
            this.changeFieldValue = setFieldValue
            this.handleChange = handleChange

            if (dirty && !isValid && this.firstItem)
              this.firstItem.scrollIntoView({ behavior: 'smooth' })

            setFilterValues(isValid ? values : null)
            return active ? (
              <Body>
                <HeaderText>Parâmetros - Similaridade</HeaderText>
                <Text>
                  Endereço:{' '}
                  {formattedAddress ||
                    'Selecione um endereço para utilizar a similaridade!'}
                </Text>
                <Form onSubmit={handleSubmit}>
                  <PriceContainer>
                    <ValueWrapper
                      title={disabled ? 'Selecione um endereço antes!' : 'Area'}
                      width="50%"
                    >
                      <FilterLabel>Area</FilterLabel>
                      <Input
                        name="area"
                        type="number"
                        placeholder="Area"
                        min={0.0}
                        step={0.5}
                        disabled={disabled}
                        value={values.area}
                        onChange={e =>
                          this.handleInputChange(values, e, 'area')
                        }
                      />
                      {errors.area && <Error>{errors.area}</Error>}
                    </ValueWrapper>
                  </PriceContainer>
                  <FeaturesContainer>
                    <Feature
                      title={
                        disabled ? 'Selecione um endereço antes!' : 'Garagens'
                      }
                    >
                      <FilterLabel>Garagens</FilterLabel>
                      <Number
                        disabled={disabled}
                        placeholder="N/A"
                        inputWidth="100%"
                        countWidth="72%"
                        name="garage"
                        min={0}
                        value={values.garage}
                        onChange={e =>
                          this.handleInputChange(values, e, 'garage')
                        }
                      />
                    </Feature>
                  </FeaturesContainer>
                </Form>
              </Body>
            ) : (
              ''
            )
          }}
        </Formik>
      </FilterBar>
    )
  }
}

export default FilterBarComponent
